import { Button, Image, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProcessParameters extends Layout {
    buttonSettlementMessages: Button;
    imageIcon: Image;
    labelDateHEader: Label;
    labelHeaderOne: Label;
    labelHeaderTwo: Label;
    labelSelectionDescr: Label;
    panelDetails: Panel;
    panelImage: Panel;
    panelRecordSelection: Panel;
    switchPrintSummariesToImaging: Switch;
    textboxCheckDate: Textbox;
    textboxEndDate: Textbox;
    textboxOverrideCutoff: Textbox;
    textboxPayrollCutoff: Textbox;
    textboxStartDate: Textbox;
}
